var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import translations from './translations';
import ArrrowDownImage from "../../common/images/arrow-down-white.svg";
import css from './style.pcss';
var RTLSportNav = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportNav, _LitElement);
  function RTLSportNav() {
    var _this;
    _classCallCheck(this, RTLSportNav);
    _this = _callSuper(this, RTLSportNav);
    _this.language = 'lu';
    _this.type = 'large';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLSportNav, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportNav.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      // Results
      var dataAPI = `https://api-gate.rtl.lu/sport/sports/${this.sport}/competitions`;
      fetch(dataAPI).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "_showRound",
    value: function _showRound(e, type) {
      if (e.target.value) {
        if (this.language == 'fr') this.link = '/sport/resultats';
        if (this.link == undefined) {
          this.link = "";
          var pathFiltered = window.location.pathname.substr(1).split("\/").filter(function (item) {
            return item != '' && item.indexOf(".html") == -1;
          });
          for (var i = 0; i <= 1; i++) {
            this.link += '/' + pathFiltered[i];
          }
          this.link += '/resultater';
        }
        document.location.href = `${this.link}/${type}?c=${e.target.value}`;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.data == undefined) return html(_t || (_t = _`Loading...`));
      var currentComp = this.competition;
      if (!currentComp) {
        var urlParams = new URLSearchParams(window.location.search);
        currentComp = urlParams.get('c');
      }

      //console.log("HERE: " + currentComp);

      var intCompetitions = [{
        name: this._getTranslation('comp_int'),
        data: [{
          id: 'GN1W6NCMFGTF5KA',
          name: "Bundesliga"
        }, {
          id: 'GNFVGF53ZV45RGD',
          name: "2. Bundesliga"
        }, {
          id: 'GN014T98KG1G83A',
          name: "Ligue1"
        }, {
          id: 'GNEXQ9MT7JFW81J',
          name: "Pro League"
        }, {
          id: 'GNA9YQRKTK2PMAQ',
          name: "Premier League"
        }, {
          id: 'GN310TWFS1MCQF3',
          name: "Primeira Liga"
        }, {
          id: 'GNAFP63G4AA70VV',
          name: "Serie A"
        }, {
          id: 'GN18KWTNXXSPP8X',
          name: "La Liga"
        }]
      }, {
        name: this._getTranslation('comp_eu'),
        data: [{
          id: 'GN4704RJ2JE0GXJ',
          name: this._getTranslation('champions_league')
        }, {
          id: 'GN2213RC2QMXWAG',
          name: "Europa League"
        }, {
          id: 'GNA69HDKTQ9SY63',
          name: "Nations League"
        }, {
          id: 'GNEY7Y7MY700285',
          name: this._getTranslation('wm_qualification')
        }]
      }];
      return html(_t2 || (_t2 = _`
            <style>${0}</style>
            <div class="rtl-sport-nav-c">
                <div class="rtl-sport-nav__item${0}">
                    <select class="rtl-sport-nav__select rtl-sport-nav__select--national" @change=${0} style="background: url('${0}') no-repeat; background-position: right">
                    <option hidden>${0}</option>
                    ${0}
                    </select>
                </div>

                ${0}

            </div>
        `), css, this.sport == 1 ? ' rtl-sport-nav__item--national' : ' rtl-sport-nav__item--other', function (e) {
        return _this3._showRound(e, 'national');
      }, ArrrowDownImage, this._getTranslation('results_nat'), this.data.map(function (competition) {
        return html(_t3 || (_t3 = _`
                        ${0}
                    `), currentComp == competition.id ? html(_t4 || (_t4 = _`<option value="${0}" selected>${0}</option>`), competition.id, competition.name) : html(_t5 || (_t5 = _`<option value="${0}">${0}</option>`), competition.id, competition.name));
      }), this.sport == 1 ? html(_t6 || (_t6 = _`
                <div class="rtl-sport-nav__item rtl-sport-nav__item--international">
                    <select class="rtl-sport-nav__select rtl-sport-nav__select--international" @change=${0} style="background: url('${0}') no-repeat; background-position: right">
                        <option hidden>${0}</option>
                        ${0}
                    </select>
                </div>
                `), function (e) {
        return _this3._showRound(e, 'international');
      }, ArrrowDownImage, this._getTranslation('results_int'), intCompetitions.map(function (compgroup) {
        return html(_t7 || (_t7 = _`
                            <optgroup label="${0}">
                            ${0}
                            </optgroup>
                        `), compgroup.name, compgroup.data.map(function (competition) {
          return html(_t8 || (_t8 = _`
                                ${0}
                            `), currentComp == competition.id ? html(_t9 || (_t9 = _`<option value="${0}" selected>${0}</option>`), competition.id, competition.name) : html(_t10 || (_t10 = _`<option value="${0}">${0}</option>`), competition.id, competition.name));
        }));
      })) : ``);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        language: {
          type: String
        },
        link: {
          type: String
        },
        sport: {
          type: Number
        },
        competition: {
          type: Number
        }
      };
    }
  }]);
  return RTLSportNav;
}(LitElement);
export { RTLSportNav as default };
window.customElements.define('rtl-sport-nav', RTLSportNav);